import { IExportDeductionItemRepository, IExportDeductionItemRequest } from "@/core/repositories/export/export.deductionItem";

export class ExportDeductionItemUseCase {
  constructor(private readonly exportDeductionItemRepository: IExportDeductionItemRepository) {}

  async execute(body: IExportDeductionItemRequest): Promise<{ signedUrl: string; success: boolean }> {
    return this.exportDeductionItemRepository.exportDeductionItem(body);
  }
}
